import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { QuestionCard } from './QuestionCard';
import { DragHandle } from './DragHandle';
import type { Question, VisibilityCondition } from './types';

interface SortableQuestionCardProps {
  question: Question;
  globalIndex: number;
  allQuestions: Question[];
  isReadOnly: boolean;
  onRemove: (questionId: string) => void;
  onQuestionChange: (questionId: string, field: keyof Question, value: any) => void;
  onTypeChange: (questionId: string, type: string) => void;
  onOptionChange: (questionId: string, index: number, value: string) => void;
  onAddOption: (questionId: string) => void;
  onRemoveOption: (questionId: string, index: number) => void;
  onToggleCondition: (globalIndex: number) => void;
  onConditionChange: (globalIndex: number, field: keyof VisibilityCondition, value: any) => void;
  onConditionValueToggle: (globalIndex: number, value: string) => void;
  onToggleFlag: (questionId: string) => void;
  onFlagChange: (questionId: string, field: string, value: any) => void;
  onFlagValueToggle: (questionId: string, value: string) => void;
}

export const SortableQuestionCard: React.FC<SortableQuestionCardProps> = ({
  question,
  isReadOnly,
  ...rest
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: `q-${question.id}`, disabled: isReadOnly });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <QuestionCard
        question={question}
        isReadOnly={isReadOnly}
        dragHandle={!isReadOnly ? <DragHandle attributes={attributes} listeners={listeners} /> : undefined}
        {...rest}
      />
    </div>
  );
};
